import { ObjectTypes } from "@common/enums/object-types";
import { CollectionRecord } from '@common/data-models/records/collection-record';
import { Record } from '@common/data-models/records/record';
import { PSTFieldNames } from "@common/data-models/fields/pst-field-names";
import { DateTime } from '@suite/common/data-models/complex-types/date-time';
import { MultiValue } from '@common/data-models/complex-types/multi-value';
import { FieldDef } from "@common/data-models/service/field-def";
import { ExternalApiDataPublicationList } from "../service/external-api-data-publication-list";
import { PublicationRecord } from "./publication-record";

export class PublicationListRecord extends CollectionRecord {

    public initialize() {
        this.type = ObjectTypes.PUBLICATIONLIST;
        super.initialize();
    }

    public get publicationChannelGUID(): string { return this.getAs<string>(PSTFieldNames.PSTPublicationChannelGUID); }
    public set publicationChannelGUID(value: string) { this.set(PSTFieldNames.PSTPublicationChannelGUID, value); }

    public get revisionNumber(): string { return this.getAs<string>(PSTFieldNames.PSTPublicationListRevisionNumber); }
    public set revisionNumber(value: string) { this.set(PSTFieldNames.PSTPublicationListRevisionNumber, value); }


    public get channelName(): string { return this.getAs<string>(PSTFieldNames.PSTPublicationChannelName); }
    public set channelName(value: string) { this.set(PSTFieldNames.PSTPublicationChannelName, value); }

    public get editionName(): string { return this.getAs<string>(PSTFieldNames.PSTPublicationListEditionName); }
    public set editionName(value: string) { this.set(PSTFieldNames.PSTPublicationListEditionName, value); }

    public get publicationSequenceCollection(): string { return this.getAs<string>(PSTFieldNames.PSTPublicationSequenceCollection); }
    public set publicationSequenceCollection(value: string) { this.set(PSTFieldNames.PSTPublicationSequenceCollection, value); }

    public get publicationTime(): DateTime { return this.getAs<DateTime>(PSTFieldNames.PSTPublicationTime); }
    public set publicationTime(value: DateTime) { this.set(PSTFieldNames.PSTPublicationTime, value); }

    public get publishedTime(): DateTime { 
        const prop = this.getAs<DateTime>(PSTFieldNames.PSTPublicationListPublishedTime); 
        if(prop && (prop.get().getUTCFullYear() == 1800)) {
            return null;
        }
        return prop;
    }
    public set publishedTime(value: DateTime) { this.set(PSTFieldNames.PSTPublicationListPublishedTime, value); }
    
    public get publishedBy(): MultiValue<string> { return this.getAs<MultiValue<string>>(PSTFieldNames.PSTPublicationListPublishedBy); }
    public set publishedBy(value: MultiValue<string>) { this.set(PSTFieldNames.PSTPublicationListPublishedBy, value); }

    public get publicationStatus(): MultiValue<string> { return this.getAs<MultiValue<string>>(PSTFieldNames.PSTPublicationStatus); }
    public set publicationStatus(value: MultiValue<string>) { this.set(PSTFieldNames.PSTPublicationStatus, value); }

    private _publicationListSections: Array<string>;

    public initializeSections() {
        if (this.publicationSequenceCollection && this.publicationSequenceCollection.trim().length > 0) {
            var publicationSequenceCollection = JSON.parse(this.publicationSequenceCollection);
            if (publicationSequenceCollection["SectionsSequence"]) {
                this._publicationListSections = publicationSequenceCollection["SectionsSequence"];
            } else {
                this._publicationListSections = Object.keys(publicationSequenceCollection);
            }
        } else {
            this._publicationListSections = [];
        }
    }

    public get publicationListSections(): Array<string> {
        if (!this._publicationListSections) this.initializeSections();
        return this._publicationListSections;
    }

    public addSection(section: string, index: number) {
        if (!this._publicationListSections) this.initializeSections();
        this._publicationListSections.splice(index, 0, section);
    }

    public editSection(oldSection: string, newSection: string) {
        if (!this._publicationListSections) this.initializeSections();
        let idx = this._publicationListSections.indexOf(oldSection);
        if (idx > -1) {
            this._publicationListSections.splice(idx, 1, newSection);
        }
    }

    public removeSection(section: string) {
        if (!this._publicationListSections) this.initializeSections();
        let idx = this._publicationListSections.indexOf(section);
        if (idx > -1) {
            this._publicationListSections.splice(idx, 1);
        }
    }

    private static _fieldDefsDict: { [id: string]: FieldDef } = null;
    public get fieldDefsDict(): { [id: string]: FieldDef } {
        if (!PublicationListRecord._fieldDefsDict) {
            PublicationListRecord._fieldDefsDict = {};
            for (let key in Record.globalTablesService.FieldDefsDict) {
                if (Record.globalTablesService.FieldDefsDict[key].PublicationListProp) {
                    PublicationListRecord._fieldDefsDict[key] = Record.globalTablesService.FieldDefsDict[key];
                }
            }
        }
        return PublicationListRecord._fieldDefsDict;
    }

    public getExternalApiData(actionName: string, userId: string, channelSections?: { [id: string]: Array<PublicationRecord> }): ExternalApiDataPublicationList {
        return new ExternalApiDataPublicationList(actionName, this.database, this.path.fullPath, this.guid, userId, this, channelSections);
    }
}
